import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  // GET
  getData(endpoint: string): Observable<any> {
    const headers = new HttpHeaders({
    });
    return this.http.get<any>(`${environment.apiUrl}${endpoint}`, {
      headers: headers,
    });
  }

  // POST
  postData(endpoint: string, body: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}${endpoint}`, body);
  }

  // PUT
  putData(endpoint: string, body: any): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}${endpoint}`, body);
  }

  // DELETE
  deleteData(endpoint: string): Observable<any> {
    return this.http.delete<any>(`${environment.apiUrl}${endpoint}`);
  }
}
